var exports = {
  "k": "xe564cbfb--e75d2f--container",
  "n": "xe564cbfb--e75d2f--link",
};

module.exports = exports;
